import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const modelKeys = [
  "text",
  "email",
  "textArea",
  "url",
  "date",
  "dateTime",
  "integer",
  "decimal",
  "money",
  "phone",
  "list",
  "multiList",
  "boolean",
] as const;

export type ModelKey = (typeof modelKeys)[number];

interface ModelsState {
  [key: string]: Record<string, any>;
}

const initialState: ModelsState = Object.fromEntries(modelKeys.map((key) => [key, {}]));

const modelsSlice = createSlice({
  name: "models",
  initialState,
  reducers: {
    setModel(state, action: PayloadAction<{ model: ModelKey; key: string; value: any }>) {
      state[action.payload.model][action.payload.key] = action.payload.value;
    },
    resetModels(state) {
      modelKeys.forEach((key) => {
        state[key] = {};
      });
    },
  },
});

export const { setModel, resetModels } = modelsSlice.actions;
export default modelsSlice.reducer;
